import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { AsyncPipe } from '@angular/common';
import { Observable, filter, map, pairwise, switchMap } from 'rxjs';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { SecondsToTimePipe } from '../../pipes/seconds-to-time.pipe';
import { SessionExpiryDialogData } from './SessionExpiryDialogData';

@Component({
  selector: 'app-session-expiry-dialog',
  templateUrl: './session-expiry-dialog.component.html',
  styleUrls: ['./session-expiry-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, AsyncPipe, TranslatePipe, SecondsToTimePipe]
})
export class SessionExpiryDialogComponent {
  readonly announcement$: Observable<string>;

  constructor(
    public readonly dialogRef: MatDialogRef<SessionExpiryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: SessionExpiryDialogData,
    private readonly translatePipe: TranslatePipe
  ) {
    this.dialogRef.disableClose = true;

    const milestones = [
      { seconds: 60, key: 'dialog.session.expiry.announcement.minute' },
      { seconds: 30, key: 'dialog.session.expiry.announcement.30.seconds' },
      { seconds: 10, key: 'dialog.session.expiry.announcement.10.seconds' }
    ];

    this.announcement$ = this.data.countdown$.pipe(
      pairwise(),
      map(([previous, remaining]) => {
        const crossed = milestones.filter(milestone => previous > milestone.seconds && remaining <= milestone.seconds);
        return crossed.length ? crossed[crossed.length - 1].key : null;
      }),
      filter((key): key is string => key !== null),
      switchMap(key => this.translatePipe.transform(key))
    );

  }

  continueSession(): void {
    this.dialogRef.close('continue');
  }

  signOut(): void {
    this.dialogRef.close('logout');
  }

}
